import { useNavigate } from "react-router-dom";

const STEPS = [
  ["01", "Tell us about your case", "Share your complaint, specialty and what you need."],
  ["02", "Share your reports", "Upload scans, labs and prescriptions securely."],
  ["03", "A specialist reviews", "A registered specialist studies your records carefully."],
  ["04", "Get your opinion", "Receive a clear written opinion or a video consult."],
];

export default function Services() {
  const nav = useNavigate();
  return (
    <section className="pgwrap">
      <span className="pg-eyebrow">Services</span>
      <h2 className="pg-h2">What we offer</h2>
      <div className="grid-auto" style={{ marginTop: 18 }}>
        <div className="card2">
          <h4 style={{ fontFamily: "Fraunces,serif", fontWeight: 540, fontSize: 21, margin: "0 0 8px" }}>Written second opinion</h4>
          <p style={{ color: "var(--slate)", fontSize: 14, margin: 0 }}>A specialist reviews your reports and returns a clear, signed written opinion, typically within about 36 hours.</p>
        </div>
        <div className="card2">
          <h4 style={{ fontFamily: "Fraunces,serif", fontWeight: 540, fontSize: 21, margin: "0 0 8px" }}>Video consultation</h4>
          <p style={{ color: "var(--slate)", fontSize: 14, margin: 0 }}>A scheduled video call with a specialist to discuss your case, your reports and your options directly.</p>
        </div>
      </div>

      <h2 className="pg-h2" style={{ fontSize: 26, marginTop: 46 }}>How it works</h2>
      <div className="how-steps" style={{ marginTop: 16 }}>
        {STEPS.map(([n, h, p]) => (
          <div className="how-step" key={n}>
            <div className="num">{n}</div><h4>{h}</h4><p>{p}</p>
          </div>
        ))}
      </div>

      <h2 className="pg-h2" style={{ fontSize: 26, marginTop: 46 }}>Built on the guidelines</h2>
      <p className="pg-lead">Every consultation follows India’s Telemedicine Practice Guidelines 2020, and your personal and health information is handled in line with the Digital Personal Data Protection Act 2023.</p>
      <div style={{ marginTop: 26 }}>
        <button className="pg-btn pg-btn-green pg-btn-lg" onClick={() => nav("/book")} data-testid="services-book">Book a consultation</button>
      </div>
    </section>
  );
}
